import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import styled, { createGlobalStyle } from 'styled-components';

import whiteBackground from './assets/shapes.png';
import blackBackground from './assets/shapes-black.png';

import {
  HOME_URL,
  JOBS_URL,
  CRITERIA_URL,
  CONTACT_URL,
  FAQ_APP_URL,
  FAQ_EMP_URL,
  SUCCESS_URL
} from './constants/navRoutes';

import Footer from './components/common/footer/index';
import Header from './components/common/header';

import {
  Contact,
  Criteria,
  ApplicantFaq,
  EmployersFaq,
  Jobs,
  JobsBoard,
  Success
} from './components/pages';

const GlobalStyle = createGlobalStyle`
  body {
    background-image: url(${props => props.background || whiteBackground});
  }
`;

const AppContainer = styled.div`
  position: relative;
  min-height: 100vh;
`;

const Spacing = styled.div`
  padding: 4em;
`;

const App = () => {
  const [title, setTitle] = React.useState('Jobs Board');
  const [employersRecord, setEmployersRecord] = React.useState(null);
  const [schemesRecord, setSchemesRecord] = React.useState(null);
  const [active, setActive] = React.useState(false);
  const [modalIsOpen, setModalIsOpen] = React.useState(false);

  React.useEffect(() => {
    fetch('.netlify/functions/airtableEmployers')
      .then(result => result.json())
      .then(json => setEmployersRecord(json))
      .catch(err => console.log(err));

    fetch('.netlify/functions/airtableSchemes')
      .then(result => result.json())
      .then(json => setSchemesRecord(json))
      .catch(err => console.log(err));
  }, []);

  const setGlobalStyle = () => {
    return title === "Jobs" ? <GlobalStyle background={blackBackground}/> : <GlobalStyle />
  }

  return (
    <AppContainer>
      {setGlobalStyle()}
      <Router>
        <Header title={title} setTitle={setTitle} />
        <Route
          path={HOME_URL}
          exact
          render={() => <JobsBoard setTitle={setTitle} />}
        />
        <Route
          path={JOBS_URL}
          render={() => <Jobs employersRecord={employersRecord} schemesRecord={schemesRecord} active={active} setActive={setActive} modalIsOpen={modalIsOpen} setModalIsOpen={setModalIsOpen} setTitle={setTitle} />}
        />
        <Route
          path={CRITERIA_URL}
          render={() => <Criteria setTitle={setTitle} schemesRecord={schemesRecord} modalIsOpen={modalIsOpen} setModalIsOpen={setModalIsOpen} />}
        />
        <Route
          path={CONTACT_URL}
          exact
          render={() => <Contact setTitle={setTitle} />}
        />
        <Route
          path={SUCCESS_URL}
          render={() => <Success setTitle={setTitle} />}
        />
        <Route
          path={FAQ_APP_URL}
          render={() => <ApplicantFaq setTitle={setTitle} />}
        />
        <Route
          path={FAQ_EMP_URL}
          render={() => <EmployersFaq setTitle={setTitle} />}
        />
        <Spacing />
        <Footer setTitle={setTitle} />
      </Router>
    </AppContainer>
  );
};

export default App;
